import React from 'react'
import Link from 'gatsby-link'

import './header.scss'

const Header = ({ page, siteInfo }) => {
  const gradients = () => {
    return (
      <defs>
        <linearGradient
          id="t1"
          x1="129.18"
          y1="381.7"
          x2="293.83"
          y2="381.7"
          gradientTransform="matrix(0.91, 0.42, -0.42, 0.91, 54.4, -340.59)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#9cdcff" />
          <stop offset="13%" stopColor="#96d3f8" />
          <stop offset="35%" stopColor="#84bbe6" />
          <stop offset="62%" stopColor="#6894c9" />
          <stop offset="94%" stopColor="#425fa1" />
          <stop offset="100%" stopColor="#395398" />
        </linearGradient>
        <linearGradient
          id="t2"
          x1="42.76"
          y1="300.2"
          x2="232.36"
          y2="300.2"
          gradientTransform="translate(-55.94 -194.25) rotate(-2.45)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#b620b4" />
          <stop offset="23%" stopColor="#ad23b5" />
          <stop offset="60%" stopColor="#952bb8" />
          <stop offset="100%" stopColor="#7437bc" />
        </linearGradient>
        <radialGradient
          id="t3"
          cx="0.65"
          cy="196.26"
          r="256.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#b620b4" />
          <stop offset="16%" stopColor="#a227b6" />
          <stop offset="45%" stopColor="#7437bc" />
          <stop offset="58%" stopColor="#623fb1" />
          <stop offset="85%" stopColor="#444e9f" />
          <stop offset="100%" stopColor="#395398" />
        </radialGradient>
      </defs>
    )
  }
  return (
    <div data-page={page} className="header">
      <Link className="header-link" to="/">
        <div className="header-container">
          <svg
            id="logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 191.19 196.23"
          >
            {gradients()}
            <title>logo</title>
            <path
              className="t1"
              fill="url(#t1)"
              d="M123.33,26.09,39,44.73C7,51.81-5.33,90.86,16.8,115l58.31,63.71c22.12,24.17,62.11,15.33,72-15.91l26-82.35C183,49.23,155.32,19,123.33,26.09Z"
            />
            <path
              className="t2"
              fill="url(#t2)"
              d="M94.64,11.23,17.87,74.44c-29.12,24-21.37,70.5,14,83.73L125,193c35.33,13.23,71.73-16.75,65.53-54L174.13,41C167.93,3.78,123.76-12.76,94.64,11.23Z"
            />
            <path
              className="t3"
              fill="url(#t3)"
              d="M59.44,35.6,16.26,110.4c-16.38,28.37,4.1,63.84,36.86,63.84h86.37c32.77,0,53.24-35.47,36.86-63.84L133.16,35.6C116.78,7.23,75.82,7.23,59.44,35.6Z"
            />
            <circle className="c" cx="97.5" cy="107.5" r="35">
              <animate
                attributeType="XML"
                attributeName="stroke-dashoffset"
                from="220"
                to="20"
                dur="2s"
                repeatCount="1"
              />
            </circle>
            <text className="h" x="100" y="100" dx="-20" dy="25" rotate="-5">
              H
            </text>
          </svg>
          <div className="title-container">
            <div className="site-title">{siteInfo.title}</div>
            <div className="site-desc">{siteInfo.description}</div>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/header.js